import React from 'react';
import { Outlet } from 'react-router-dom';
import RegisterHeader from '../components/Headers/RegisterHeader';
import { Box,} from '@mui/material';
const AuthRegisterLayout = () => (
  <>
<Box sx={{}}>
    <RegisterHeader />
    <main style={{ padding: '0px',margin:"0px" }}>
      <Outlet />
    </main>
    </Box>
  </>
);

export default AuthRegisterLayout;